import { ActionIcon, Header } from "@mantine/core"
import { IconLogout } from "@tabler/icons"
import { useContext } from "react"
import { Link } from "react-router-dom"
import logo from "../../assets/logo.png"
import { TOP_BAR_HEIGHT } from "../../miscellaneous/constants"
import AuthenticationContext from "../AuthenticationContext"
import Tabs from "../Tabs"
import Props from "./TopBar.types"

const LOGO_PADDING = 4

const TopBar = ({ mobile }: Props) => {
  const [, setToken] = useContext(AuthenticationContext)

  return (
    <Header
      height={TOP_BAR_HEIGHT}
      styles={{
        root: {
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: "var(--main-color)",
        },
      }}
    >
      <Link to="/">
        <img
          src={logo}
          alt=""
          style={{
            height: `calc(100% - ${LOGO_PADDING * 2}px)`,
            padding: LOGO_PADDING + "px",
            marginLeft: "16px",
          }}
        />
      </Link>
      {!mobile && <Tabs />}
      <ActionIcon
        variant="default"
        style={{
          margin: "15px",
          backgroundColor: "transparent",
          borderColor: "var(--contrasting-color)",
        }}
        size="lg"
        onClick={() => setToken("")}
      >
        <IconLogout />
      </ActionIcon>
    </Header>
  )
}

export default TopBar
